var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProcesses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 32,
    viewBox: "0 0 30 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1928_465)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9987 22.6223C9.41889 22.6223 4.89844 18.0311 4.89844 12.364C4.89844 10.3223 5.48578 8.42258 6.49615 6.82471",
    stroke: "#1F57A0",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.998 2.10596C20.5778 2.10596 25.0983 6.69718 25.0983 12.3643C25.0983 14.406 24.5109 16.3057 23.5006 17.9036",
    stroke: "#1F57A0",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3184 12.3606C18.3184 14.2213 16.8291 15.7339 14.9971 15.7339C14.1091 15.7339 13.277 15.3824 12.6477 14.7468C12.0219 14.1112 11.6758 13.2626 11.6758 12.3606C11.6758 10.5 13.1652 8.98735 14.9971 8.98735M19.619 6.57989C19.535 6.49467 19.3847 6.47692 19.2833 6.54438L18.0317 7.26165C17.9303 7.32912 17.7555 7.33622 17.6437 7.28296L16.6648 6.87106C16.5494 6.832 16.434 6.70062 16.406 6.57634L16.0215 5.16666C15.997 5.04949 15.8781 4.95361 15.7593 4.95361H14.235C14.1161 4.95361 13.9972 5.04949 13.9728 5.16666L13.5882 6.57634C13.5602 6.69707 13.4448 6.82845 13.3295 6.86751L12.3506 7.27941C12.2422 7.33267 12.0674 7.32557 11.9625 7.2581L10.7074 6.54083C10.606 6.47692 10.4557 6.49112 10.3718 6.57634L9.29848 7.67C9.21457 7.75522 9.19709 7.9079 9.26352 8.01088L9.96973 9.28207C10.0362 9.38505 10.0431 9.56259 9.9907 9.67622L9.58516 10.6704C9.5467 10.7876 9.41734 10.9048 9.29498 10.9332L7.90703 11.3238C7.79166 11.3487 7.69727 11.4694 7.69727 11.5901V13.1383C7.69727 13.259 7.79166 13.3797 7.90703 13.4046L9.29498 13.7952C9.41385 13.8236 9.5432 13.9408 9.58166 14.0579L9.98721 15.0522C10.0396 15.1622 10.0327 15.3398 9.96623 15.4463L9.26002 16.7211C9.19709 16.824 9.21108 16.9767 9.29498 17.0619L10.3718 18.152C10.4557 18.2373 10.606 18.255 10.7074 18.1876L11.959 17.4703C12.0604 17.4028 12.2352 17.3957 12.3471 17.449L13.326 17.8609C13.4414 17.8999 13.5567 18.0313 13.5847 18.1556L13.9693 19.5653C13.9937 19.6824 14.1126 19.7783 14.2315 19.7783H15.7558C15.8746 19.7783 15.9935 19.6824 16.018 19.5653L16.4025 18.1556C16.4305 18.0349 16.5459 17.9035 16.6613 17.8644L17.6402 17.4525C17.7485 17.3993 17.9233 17.4064 18.0282 17.4738L19.2833 18.1911C19.3847 18.255 19.535 18.2408 19.619 18.1556L20.6923 17.0619C20.7762 16.9767 20.7936 16.824 20.7272 16.7211L20.021 15.4499C19.9546 15.3469 19.9476 15.1693 20 15.0593L20.4056 14.065C20.444 13.9479 20.5734 13.8307 20.6958 13.8023L22.0837 13.4117C22.1991 13.3868 22.2935 13.2661 22.2935 13.1454V11.5972C22.2935 11.4765 22.1991 11.3558 22.0837 11.3309L20.6958 10.9403C20.5769 10.9119 20.4475 10.7947 20.4091 10.6775L20.0035 9.68332C19.9511 9.57324 19.9581 9.3957 20.0245 9.28918L20.7307 8.01443C20.7936 7.91145 20.7797 7.75877 20.6958 7.67355L19.619 6.58344V6.57989Z",
    stroke: "#1F57A0",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9979 2.10575H4.56201V0.28418L0.279297 3.52964L4.56201 6.7751V4.95352H11.8758",
    stroke: "#1F57A0",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.998 22.6226H25.4374V24.4406L29.7201 21.1952L25.4374 17.9497V19.7713H18.1236",
    stroke: "#1F57A0",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1928_465"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 31.5385,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcesses);
export default __webpack_public_path__ + "static/media/processes.e38978f48955ce25ff5eba45f69c9b0d.svg";
export { ForwardRef as ReactComponent };